<template>
  <div>
    <div ref="pdfContent">
      <div>
        <div class="row plan-title-wrapper">
          <div class="col-6 plan-title-left">
            <h1>PLAN HIGIJENE</h1>
            <h2>{{ plan.parentCleaningArea }}</h2>
          </div>
          <div class="col-6 plan-title-right">
            <h1>{{ plan.company }}</h1>
            <h2>
              DATUM KREIRANJA PLANA:
              {{ formatDate(plan.cleaningPlanDate, 'dd. MM. yyyy.') }}
            </h2>
          </div>
        </div>
        <!--/Plan title row-->

        <div class="row plan-table-wrapper">
          <table>
            <tr>
              <th style="width: 10%">
                PODRUČJE <br />
                PRIMJENE
              </th>
              <th style="width: 10%">
                KOJE <br />
                SREDSTVO
              </th>
              <th style="width: 10%">
                ČIME <br />
                ČISTITI
              </th>
              <th style="width: 40%">
                KAKO <br />
                KORISTITI?
              </th>
              <th style="width: 10%">
                KADA <br />
                KORISTITI
              </th>
              <th style="width: 10%">NAPOMENA</th>
              <th style="width: 10%">
                ODGOVORNA <br />
                OSOBA
              </th>
            </tr>
            <tr v-for="item in plan.cleaningPlanItems" :key="item.id">
              <td style="text-align: center">
                <img v-if="item.applianceAreaIcon"
                  class="plan-image"
                  :src="`${baseUrl}${item.applianceAreaIcon}`"
                />
                <p class="plan-image-description">{{ item.applianceArea }}</p>
              </td>
              <td style="text-align: center">
                <img
                  class="plan-image"
                  :src="`${baseUrl}${item.cleaningProductIcon}`"
                />
                <p class="plan-image-description">
                  {{ item.cleaningProduct }}
                </p>
              </td>
              <td style="text-align: center">
                <img
                  class="plan-image"
                  :src="`${baseUrl}${item.helpingEquipmentIcon}`"
                />
                <p class="plan-image-description">
                  {{ item.helpingEquipment }}
                </p>
              </td>
              <td>
                <p class="how-to-use" v-html="item.howToUseItem">
                </p>
              </td>
              <td>
                <p class="how-to-use how-to-use-left">
                  {{ item.whenToUseItem }}
                </p>
              </td>
              <td>
                <p class="how-to-use how-to-use-left">
                  {{ item.note || 'N/A' }}
                </p>
                <div class="warning-icons-wrapper">
                  <div
                    class="warning-icon"
                    v-for="icon in planIcons(item.cleaningPlanNoteIconsIds)"
                    :key="icon.id"
                  >
                    <img
                      class="icon-image"
                      :alt="icon.title"
                      :src="`${baseUrl}${icon.iconUrl}`"
                    />
                  </div>
                </div>
              </td>
              <td>
                <p class="how-to-use how-to-use-left">
                  {{ item.responsiblePerson }}
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row plan-title-wrapper footer-title-wrapper">
        <div class="col-6 plan-title-left">
          <img v-if="plan.logoUrl"
            :src="`${baseUrl}${plan.logoUrl}`"
            :alt="plan.parentCleaningArea"
          />
          <h4 v-else>{{ plan.parentCleaningArea }}</h4>
        </div>
        <div class="col-6 plan-title-right">
          <h2 v-html="plan.infoFooterText"></h2>
        </div>
      </div>
    </div>
    <!--/Plan title row-->

    <div
      class="action-buttons d-flex justify-content-between"
      style="margin-top: 2rem"
    >
      <div>
        <!--<button type="button" data-bs-toggle="modal" data-bs-target="#delete-modal" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"><i class="bx bx-sync text-4 me-2"></i> Resetiraj</button>-->
      </div>
      <div class="d-flex gap-3 action-buttons">
        <a
          @click="goBack"
          class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          Natrag
        </a>
        <button
          type="button"
          @click="exportToPDF"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-download text-4 me-2"></i> Preuzmi (PDF)
        </button>
        <button
          type="button"
          @click="printCleaningPlan"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-printer text-4 me-2"></i> Printaj
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import html2pdf from 'html2pdf.js';

export default {
  name: 'PrintCleaningPlan',
  computed: {
    plan() {
      return this.$store.getters.getCleaningPlan;
    },
    icons() {
      return this.$store.getters.getCleaningPlanNoteIcons;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  methods: {
    planIcons(iconsIds) {
      return this.icons.filter((item) => {
        return iconsIds.indexOf(item.id) !== -1;
      });
    },
    printCleaningPlan() {
      window.print();
    },
    exportToPDF() {
      let content = this.$refs.pdfContent;
      let opt = {
        margin: 5,
        filename: `plan_ciscenja_${Date.now()}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true, useCORS: true},
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' } // Postavljen na landscape
      };

      html2pdf().from(content).set(opt).save();
    },
    goBack() {
      this.$router.push({ name: 'EditAddCleaningPlan', params: { id: parseInt(this.$route.params.id) } });
    }
  },
  mounted() {
    this.$store.dispatch(
      'getCleaningPlan',
      parseInt(this.$route.params.id, 10)
    );
    this.$store.dispatch('getCleaningPlanNoteIcons', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
};
</script>

<style lang="scss">
/*Plan čišćenja*/
.modal-cleaning-plan {
  max-width: 900px;
}

.report-wrapper .content-body {
  margin-left: 0 !important;
}
.report-wrapper .content-body .page-header {
  left: 0;
}
.report-wrapper table {
  background: #ffffff;
}
.plan-title-wrapper {
  background: #005fab;
  padding: 25px 15px 10px;
}

.plan-title-left {
  text-align: left;
}
.plan-title-right {
  text-align: right;
}

.plan-title-left h1 {
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  font-weight: 700;
  line-height: 0.6em;
  font-size: 1.8em;
}
.plan-title-left h2 {
  color: #e7e7e7;
  text-transform: uppercase;
  margin: 0;
  font-size: 1.4em;
}

.plan-title-right h1 {
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  font-weight: 400;
  line-height: 0.6em;
  font-size: 1.8em;
}
.plan-title-right h2 {
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  font-weight: 100;
  font-size: 1.4em;
}

h4 {
  color: #ffffff;
}

.plan-table-wrapper {
  padding-top: 0 !important;
}

.plan-table-wrapper table tr th {
  text-align: center;
  line-height: 1.2;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000000;
}
.plan-category-image,
.plan-image-description {
  text-align: center;
}

.plan-image {
  height: 100px;
  width: auto;
}

.plan-table-wrapper table tr td {
  vertical-align: top;
  padding: 5px 5px;
}
.plan-image-description {
  line-height: 1.2;
  margin: 10px 0 0;
  color: #000000;
}

.how-to-use {
  text-align: justify;
  padding-left: 5px;
  padding-right: 5px;
  color: #000000;
  line-height: 1.4em;
  margin-bottom: 0;
}
.how-to-use-left {
  text-align: left;
}
.warning-icon {
  width: 50%;
  float: left;
  text-align: center;
}

.plan-table-wrapper tr {
  border-bottom: 1px solid #000000;
}
.plan-table-wrapper tr:first-child,
.plan-table-wrapper tr:last-child {
  border-bottom: none;
}
.plan-table-wrapper tr td {
  border-right: 1px solid #000000;
}
.plan-table-wrapper tr td:nth-child(-n + 2) {
  border-right: none;
}
.plan-table-wrapper tr td:last-child {
  border-right: none;
}
.plan-table-wrapper p {
  font-size: 13px;
}
.footer-title-wrapper {
  padding-top: 10px !important;
}
.footer-title-wrapper h2 {
  line-height: 1.2;
}
.footer-title-wrapper img {
  padding-top: 5px;
  height: 35px;
}

.plan-title-right h2 {
  font-weight: 400;
}

@media print {
  .header,
  .sidebar-right,
  .sidebar-left,
  .sidebar-header,
  .page-header,
  .right-wrapper,
  footer.footer {
    display: none !important;
  }

  .page-header-left-inline-breadcrumb,
  .action-buttons,
  .right-wrapper {
    display: none !important;
  }

  .content-body {
    margin: 0;
    width: 100%;
  }

  table {
    width: 100%;
  }

  .plan-title-wrapper {
    background: #005fab !important;
    padding: 25px 15px 10px;
  }

  .plan-title-left {
    background: #005fab;
  }

  body {
    -webkit-print-color-adjust: exact !important;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  @page :footer {
    display: none;
  }

  @page {
    margin: 0;
  }

  @page :header {
    display: none;
  }
}
</style>
